<div [ngClass]="{ 'bm--bg-popup': showLicensePopup }" (click)="closeLicensePopup()">
  @if (showLicensePopup) {
    <div
      class="license-popup theme-popup-licenses"
      [ngClass]="{ 'license-popup--colorSettingsMode': colorSettingsMode }"
    >
      <!-- Spinner -->
      @if (isLoader) {
        <div class="bm--loader-box">
          <bmcore-loader></bmcore-loader>
        </div>
      }
      @if (!isLoader) {
        <div class="license-popup__container-left bm--scroll-bar" (click)="$event.stopPropagation()">
          <div class="license-popup__container-head">
            <h3 class="lic-popup__track-name bm--cut">{{ activeTrack?.name }}</h3>
            <div class="btv-icon-close theme-popup-iconClose" (click)="closeLicensePopup()"></div>
          </div>
          @if (trackLicenses.length) {
            @for (trackLicense of trackLicenses; track trackLicense) {
              <bmcore-license-popup-item
                [trackLicense]="trackLicense"
                (setFeatures)="setFeatures($event)"
                [isLicenseActive]="trackLicense.id === activeLicenseId"
                [currencySign]="currencySign"
                [lg]="lg"
              >
              </bmcore-license-popup-item>
            }
          }
          @if (!trackLicenses.length) {
            <bmcore-beats-not-found [title]="'The beat is not for sale'" (closePopupEvent)="closeLicensePopup()">
            </bmcore-beats-not-found>
          }
        </div>
        <div
          class="license-popup__container-right"
          [ngStyle]="{
            background: 'url(' + activeTrack?.images.original + ') no-repeat center / cover'
          }"
          (click)="$event.stopPropagation()"
        >
          <div class="license-popup__container-right--overlay">
            <div class="lic-popup__img-container">
              <img src="{{ activeTrack?.images.original }}" alt="{{ activeTrack?.name }} cover" />
            </div>
            <!--List of features for active license-->
            @for (trackLicense of trackLicenses; track trackLicense) {
              <div class="lic-popup__license-container">
                @if (trackLicense.id === activeLicenseId) {
                  <ul class="lic-popup__features-list bm--scroll-bar theme-popup-license-features-list">
                    @for (feature of trackLicense.features; track feature) {
                      <li class="common-license-item theme-popup-licenseDots-after">
                        {{ feature.title }}
                      </li>
                    }
                  </ul>
                }
              </div>
            }
            @if (trackLicenses.length) {
              <div class="lic-popup__btn-container">
                <bmcore-button
                  themeBtnClass="theme-btn__license-popUp"
                  themeIconClass="theme-icon__license-popUp"
                  title="{{ lg.button.addToCart }}"
                  icon="btv-icon-cart"
                  (clickHandler)="wantToAddBeat($event, activeTrack.id, activeLicenseId)"
                >
                </bmcore-button>
              </div>
            }
          </div>
        </div>
        <div class="license-popup__container-bottom">
          <img src="{{ activeTrack?.images.thumbnail }}" alt="{{ activeTrack?.name }} cover" />
          <bmcore-button
            class="license-popup__mob-btn-container"
            title="{{ lg.button.buy }}"
            icon="btv-icon-cart"
            (clickHandler)="wantToAddBeat($event, activeTrack.id, activeLicenseId)"
          >
          </bmcore-button>
        </div>
      }
    </div>
  }
</div>
